// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1pDs2","inner":"Form_inner__ta6Fj","range":"Form_range__2R9LI","name":"Form_name__3G44i","actions":"Form_actions__V9CqY"};